import { FormFieldsBox } from '@spotify/confidence-core-react';
import { MetricsV1MetricRatioMetricSpec as RatioSpec } from '@spotify/confidence-graphql';

import { MetricFilters } from '../MetricFilters';
import { AggregatedMeasurement } from './AggregatedMeasurement';

type RatioFormProps = {
  value: RatioSpec;
  entity?: string;
  factTable: string;
  onChange: (newRatioSpec: RatioSpec) => void;
};

export const RatioForm = ({
  value,
  entity = '',
  factTable,
  onChange,
}: RatioFormProps) => (
  <FormFieldsBox>
    <AggregatedMeasurement.Root
      measurement={value.numerator}
      aggregation={value.numeratorAggregation}
      entity={entity}
      factTable={factTable}
      onChange={(measurement, aggregation) => {
        onChange({
          ...value,
          numerator: measurement ? { name: measurement.name } : undefined,
          numeratorAggregation: {
            ...value.numeratorAggregation,
            ...aggregation,
          },
        });
      }}
    >
      <AggregatedMeasurement.Select
        label="Numerator"
        helperText="The value to divide."
        required={!value.denominator?.name}
        disabledOptions={
          value.denominator?.name ? [value.denominator.name] : undefined
        }
      />
      <AggregatedMeasurement.Type
        label="Numerator method"
        data-testid="numerator-method-select"
      />
      <AggregatedMeasurement.Cap
        idPrefix="ratio-numerator"
        valueLabel="numerator values"
        short
      />
    </AggregatedMeasurement.Root>

    <MetricFilters
      label="Numerator filter"
      factTable={factTable}
      filter={value.numeratorFilter}
      onChange={newFilter => {
        onChange({ ...value, numeratorFilter: newFilter });
      }}
    />

    <AggregatedMeasurement.Root
      measurement={value.denominator}
      aggregation={value.denominatorAggregation}
      entity={entity}
      factTable={factTable}
      onChange={(measurement, aggregation) => {
        onChange({
          ...value,
          denominator: measurement ? { name: measurement.name } : undefined,
          denominatorAggregation: {
            ...value.denominatorAggregation,
            ...aggregation,
          },
        });
      }}
    >
      <AggregatedMeasurement.Select
        label="Denominator"
        helperText="The value to divide by."
        required={!value.numerator?.name}
        disabledOptions={
          value.numerator?.name ? [value.numerator.name] : undefined
        }
      />
      <AggregatedMeasurement.Type
        label="Denominator method"
        data-testid="denominator-method-select"
      />
      <AggregatedMeasurement.Cap
        idPrefix="ratio-denominator"
        valueLabel="denominator values"
        short
      />
    </AggregatedMeasurement.Root>

    <MetricFilters
      label="Denominator filter"
      factTable={factTable}
      filter={value.denominatorFilter}
      onChange={newFilter => {
        onChange({ ...value, denominatorFilter: newFilter });
      }}
    />
  </FormFieldsBox>
);
